import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { setMiniSidenav, useMaterialUIController } from "./context";
import { useEffect, useState } from "react";
import { CssBaseline, styled, ThemeProvider, Typography } from "@mui/material";
import theme from "./assest/theme";
import Sidenav from "./layoutcontainers/DashboardLayout/components/Sidebar";
import routes from "./routes";
import logo from "../src/assest/images/logo.png";
import LeadAndProspectContext from "./context/apiContext/Lead-and-ProspectContext";
import "./css/app.css";
import { useAuth } from "./context/AuthContext/AuthContextProvider";
import Signin from "./pages/authentication/signin";
import SuccessPop from "./Popup/SuccessPop";
import OpprtunityContextProvider from "./pages/opportunity/OppurtunityContext";
import EmailForgot from "./pages/authentication/forgot/EmailForgot";
import ResetPassword from "./pages/authentication/forgot/ResetPassword";
import CustomerContext from "./context/apiContext/CustomerContext";
import LodingCirlce from "./components/Loading/Loding";
import LoadingContext, { useLoading } from "./context/LodingContext";
import { useSuccess } from "./context/SucccessContext";
import Sucess from "./Popup/Sucess";
import { useError } from "./context/ErrorContext";
import ErrorPopup from "./Popup/ErrorPopup";
import HandleDownloadPdf from "./pages/Quations/convertPDF/HandleDownloadPdf";
import NewSideBar from "./layoutcontainers/DashboardLayout/components/newSideBar/NewSideBar";
import AuthLoader from "./pages/authentication/signin/authLoader";

function App() {
 
  const userRole = localStorage.getItem("userRole");
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, direction, layout, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const { authenticated, setAuthenticated } = useAuth();
  const { circleLoading, setCirleLoading } = useLoading();
  const pathName = window?.location?.pathname;
  const { successStatus, setSuccessStatus, sucessTitle, setSucessTitle } =
    useSuccess();
  const { errorStatus, setErrorStatus,errormessage,setErrormessage } = useError();  
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };
  const Logo = styled(Typography)(({ isCollapsed }) => ({
    fontSize: isCollapsed ? "0px" : "24px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#6a0dad",
    transition: "font-size 0.3s ease-in-out, opacity 0.3s ease-in-out",
    opacity: isCollapsed ? 0 : 1,
  }));

  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

const getRoutes = (allRoutes) =>
  allRoutes.flatMap((route) => {
    if (route.collapse) {
      return getRoutes(route.collapse);
    }

    // Allow access only if userRole is in route.allow or if no restrictions
    const isAllowed =
    !route.allow || (Array.isArray(route.allow) && route.allow.includes(userRole));
    
    if (route.route && authenticated && isAllowed) {
      return (
        <Route
          exact
          path={route.route}
          element={route.component}
          key={route.key}
        />
      );
    }

    return [];
  });


  return (
    
    <ThemeProvider theme={theme}>
      <CustomerContext>
        <LeadAndProspectContext>
          <OpprtunityContextProvider>
            <CssBaseline />

            {layout === "dashboard" && pathName != "/authentication" && (
              <>
                {/* <Sidenav
                  color={sidenavColor}
                  brand={logo}
                  brandName="Keelis"
                  routes={routes}
                  onMouseEnter={handleOnMouseEnter}
                  onMouseLeave={han
                  dleOnMouseLeave}
                /> */}

                <NewSideBar
                  routes={routes.filter((route) => {
                    // If no restriction, show it
                    if (!route.allow) return true;
                
                    // If allow is an array and includes current user role, show it
                    if (Array.isArray(route.allow)) return route.allow.includes(userRole);
                
                    // If allow is a single role string, match it directly
                    return route.allow === userRole;
                  })}
                // routes={routes.filter(route=>route.allow!="manager") && routes.filter(route=>route.allow!="superuser")}
                brand={logo}
                brandName="CRM"
                onMouseEnter={handleOnMouseEnter}
                onMouseLeave={handleOnMouseLeave}
                />
              </>
            )}
            {circleLoading && (
              <div
                style={{ position: "fixed", inset: 0, zIndex: "1000000000000" }}
              >
                <LodingCirlce pending={circleLoading} />
                {/* <Sucess status={successStatus} title={sucessTitle} />
              <ErrorPopup status={errorStatus} /> */}
              </div>
            )}
            {successStatus && (
              <div
                style={{ position: "fixed", inset: 0, zIndex: "1000000000000" }}
              >
                {/* <LodingCirlce pending={circleLoading} /> */}
                <Sucess status={successStatus} title={sucessTitle} />
              </div>
            )}
            {errorStatus && (
              <div
                style={{ position: "fixed", inset: 0, zIndex: "1000000000000" }}
              >
                {/* <LodingCirlce pending={circleLoading} />
              <Sucess status={successStatus} title={sucessTitle} /> */}
                <ErrorPopup status={errorStatus} errormessage={errormessage} />
              </div>
            )}
            {/* <div style={{position:'fixed',inset:0,zIndex:'1000000000000'}}>
              <LodingCirlce pending={circleLoading} />
              <Sucess status={successStatus} title={sucessTitle} />
              <ErrorPopup status={errorStatus} />
            </div> */}
            <Routes>
              {getRoutes(routes)}

              <Route path="/sign-in" element={<Signin />} />
              <Route path="/sign-in/forgotemail" element={<EmailForgot />} />
                     <Route path="/authentication" element={<AuthLoader />} />
              <Route
                path="/sign-in/resetPassword/:uid/:token"
                element={<ResetPassword />}
              />
              {/* <Route path="/pdfDownlod:id" element={<HandleDownloadPdf />} /> */}
              <Route
                path="*"
                element={
                  <Navigate to={authenticated ? "/dashboard" : "/authentication"} />
                }
              />
            </Routes>
          </OpprtunityContextProvider>
        </LeadAndProspectContext>
      </CustomerContext>
    </ThemeProvider>
  );
}

export default App;
